import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsEN from './en/en.json';
import translationsCZ from './cz/cz.json';
import i18next from 'i18next';

const resources = {
  en: {
    translation: translationsEN
  },
  cz: {
    translation: translationsCZ
  }
};

i18next
  .use(initReactI18next)
  .init({
    resources,
    debug: true,
    fallbackLng: 'cz',
    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
